import React, { useState, useEffect } from 'react';

import { Box } from 'ui/box';
import { Stack } from 'ui/stack';
import { getApiHealth } from 'api/api.config';

import oldLogo from 'assets/images/old-marketview-logo.svg';
import maintenanceImage from 'assets/images/maintenance.svg';

type MaintenancePageProps = {
  children: React.ReactNode;
};

const MaintenancePage: React.FC<MaintenancePageProps> = ({ children }) => {
  const [health, setHealth] = useState(true);

  const getHealth = () => {
    if (navigator.onLine) {
      getApiHealth()
        .then((resp) => {
          // TODO: Wave 8 — type the api.config getApiHealth response shape.
          const data = (resp as { data?: { status?: string } } | undefined)
            ?.data;

          if (data && data.status === 'UP') {
            setHealth(true);
          } else if (navigator.onLine) {
            setHealth(false);
          }
        })
        .catch((err) => {
          console.error('Api Error', err);
          setHealth(false);
        });
    }
  };

  const MaintenancePoll = () => {
    setTimeout(() => {
      getHealth();
      MaintenancePoll();
    }, 300000);
  };

  useEffect(() => {
    getHealth();
    MaintenancePoll();
  }, []);

  return (
    <>
      {health ? (
        <>{children}</>
      ) : (
        <Stack
          direction="row"
          sx={{ minHeight: '100vh', justifyContent: 'center' }}
        >
          <Stack
            direction="row"
            sx={{
              width: '100%',
              px: 4,
              py: 2,
              '@media (min-width: 1024px)': { width: '50%' },
              '@media (min-width: 1280px)': { px: 16, py: 8 },
            }}
          >
            <Stack
              sx={{
                width: '100%',
                justifyContent: 'center',
                alignItems: 'center',
              }}
            >
              <img src={oldLogo} alt="MARKETview logo" className="mb-8" />

              <p className="text-xl font-light leading-normal">
                MARKETview is temporarily off-line for updates. We remain
                focused on improving data privacy and security and the
                experience that gives you complete vision into the market and
                your place within it. To reach MARKETview, please email{' '}
                <a
                  href="mailto:support@marketviewedu.com"
                  className="text-blue-700 font-light decoration-2 underline"
                >
                  support@marketviewedu.com
                </a>{' '}
                or visit our{' '}
                <a
                  href="https://marketviewedu.com/contact-us/"
                  target="_blank"
                  className="text-blue-700 font-light decoration-2 underline"
                >
                  web site contact page
                </a>
                .
              </p>
            </Stack>
          </Stack>
          <Box
            sx={{
              alignItems: 'center',
              display: 'none',
              width: '50%',
              p: 4,
              '@media (min-width: 1024px)': { display: 'flex' },
            }}
            style={{ background: 'linear-gradient(#45B8E6, #007AAB)' }}
          >
            <img
              src={maintenanceImage}
              alt="Maintenance illustration"
              className="mx-auto"
            />
          </Box>
        </Stack>
      )}
    </>
  );
};

export default MaintenancePage;
